const Enum = require('enum');

const AccountStatus = new Enum({'new':1, 'active':2, 'hold':3, 'unpaid':4, 'expiring':5});

module.exports = AccountStatus;